import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./LoginPage.module.css";
import { useAuth } from "../contexts/AuthContext";
import Button from "components/common/Button";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [alert, setAlert] = useState(null);
  const [Accessible, setAccessible] = useState(false);

  const { resetPassword } = useAuth();
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const navigate = useNavigate();



  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    console.log(token);


    if (!token) {
      navigate('/accès-interdit', { replace: true });
    }
    setAccessible(true);
  }, []);

  const from = location.state?.from || "/login";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const response = await resetPassword({ token, password, confirmPassword });
    if (!response.success) {
      if (response.errors && response.errors.errors) {
        setErrors(response.errors.errors);
        setError(null);
      } else if (response.errors) {
        setAlert({ type: 'error', message: response.errors.error });
        setTimeout(() => {
          setAlert(null);
        }, 5000);
        setErrors({});
      }
    } else {
      setErrors({});
      setError({});
      setAlert({ type: 'success', message: "Votre mot de passe a été réinitialisé avec succès." });
      setTimeout(() => {
        setAlert(null);
      }, 5000);
      navigate(from, { replace: true });
    }
  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Réinitialiser le mot de passe - Pharos</title>
        <meta name="description" content="Réinitialisez votre mot de passe pour accéder à votre compte Pharos." />
        <meta property="og:title" content="Réinitialiser le mot de passe - Pharos" />
        <meta property="og:description" content="Réinitialisez votre mot de passe pour accéder à votre compte Pharos." />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          {Accessible && <div className={styles.loginContainer}>
            <div className={styles.formContainer}>
              <h1 className="h2">Réinitialiser mot de passe</h1>
              <p className={styles.Description}>Entrez un nouveau mot de passe pour votre compte.</p>
              <form onSubmit={handleSubmit}>
                {alert && (
                  <div className={`${styles.alert} ${styles[alert?.type]}`}>
                    {alert?.message}
                  </div>
                )}
                <ul className={styles.InputsList}>
                  <li>
                    <label htmlFor="password">Saisissez un nouveau mot de passe</label>
                    <input
                      type="password"
                      name="password"
                      id="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    {error && <span className={styles.error}>{error}</span>}
                    {errors.password && <span className={styles.error}>{errors.password}</span>}
                  </li>
                  <li>
                    <label htmlFor="confirmPassword">Confirmez le nouveau mot de passe</label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={e => setConfirmPassword(e.target.value)}
                    />
                    {errors.confirmPassword && <span className={styles.error}>{errors.confirmPassword}</span>}
                  </li>
                </ul>

                <Button type="submit">Réinitialiser le mot de passe</Button>

              </form>
            </div>
            <div className={styles.image}>
              <img src={`/images/ready-to-rock.webp`} alt="Pharos"></img>
            </div>
          </div>}
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
